import { render } from "./AdvertiserInventorySourceTypeInfoSidePanel.vue?vue&type=template&id=272a34ff"
import script from "./AdvertiserInventorySourceTypeInfoSidePanel.vue?vue&type=script&lang=js"
export * from "./AdvertiserInventorySourceTypeInfoSidePanel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/53/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QItem,QItemSection,QTable,QTr,QTd});
